import React, { useEffect, useState } from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { useMembership } from "../../context/MembershipContext";
import { useIsDesktopViewport } from "../../hooks/useIsDesktopViewport";
import "./adminDesktop.css";
import {
  formatBillingStatusLabel,
  loadOrganizationBillingSnapshot,
} from "../../helpers/organizationBilling";

export function AdminSubscriptionScreen({ onBack }) {
  const { organizationId, isOrgAdmin } = useMembership();
  const isDesktop = useIsDesktopViewport();
  const [snapshot, setSnapshot] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      if (!organizationId) {
        setLoading(false);
        return;
      }
      const data = await loadOrganizationBillingSnapshot(organizationId);
      if (!cancelled) {
        setSnapshot(data);
        setLoading(false);
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, [organizationId]);

  return (
    <CrewPilotModuleShell
      title="Subscription"
      subtitle="Plan and billing overview"
      sectionLabel="Commercial"
      onBack={onBack}
      layout={PAGE_LAYOUT.FORM}
    >
      <div className="adm-narrow">
      <div className="rb-card">
        <div className="section-heading">CURRENT PLAN</div>
        {loading && <p>Loading subscription details…</p>}
        {!loading && snapshot && isDesktop && (
          <>
            <div className="adm-tiles">
              <div className="adm-tile">
                <div className="adm-tile__label">Status</div>
                <div className="adm-tile__value">{formatBillingStatusLabel(snapshot.status)}</div>
              </div>
              <div className="adm-tile">
                <div className="adm-tile__label">Plan</div>
                <div className="adm-tile__value">{snapshot.plan_key || "Standard"}</div>
              </div>
              <div className="adm-tile">
                <div className="adm-tile__label">Seat limit</div>
                <div className="adm-tile__value">
                  {snapshot.seat_limit == null ? "Unlimited" : snapshot.seat_limit}
                </div>
              </div>
              {snapshot.trial_ends_at && (
                <div className="adm-tile">
                  <div className="adm-tile__label">Trial ends</div>
                  <div className="adm-tile__value">
                    {new Date(snapshot.trial_ends_at).toLocaleDateString()}
                  </div>
                </div>
              )}
            </div>
            {snapshot._tableMissing && (
              <p className="adm-note" style={{ marginTop: "12px" }}>
                Subscription details are being set up for your organization.
                Contact Nexora Systems if you need plan changes.
              </p>
            )}
          </>
        )}
        {!loading && snapshot && !isDesktop && (
          <>
            <p style={{ marginBottom: "8px" }}>
              <strong>Status:</strong> {formatBillingStatusLabel(snapshot.status)}
            </p>
            <p style={{ marginBottom: "8px" }}>
              <strong>Plan:</strong> {snapshot.plan_key || "Standard"}
            </p>
            <p style={{ marginBottom: "8px" }}>
              <strong>Seat limit:</strong>{" "}
              {snapshot.seat_limit == null ? "Unlimited" : snapshot.seat_limit}
            </p>
            {snapshot.trial_ends_at && (
              <p style={{ marginBottom: "8px" }}>
                <strong>Trial ends:</strong>{" "}
                {new Date(snapshot.trial_ends_at).toLocaleDateString()}
              </p>
            )}
            {snapshot._tableMissing && (
              <p style={{ marginTop: "12px", opacity: 0.75, fontSize: "14px" }}>
                Subscription details are being set up for your organization.
                Contact Nexora Systems if you need plan changes.
              </p>
            )}
          </>
        )}
        <p style={{ marginTop: "16px", opacity: 0.75, fontSize: "14px" }}>
          Contact Nexora Systems to change your plan or add seats.
        </p>
        {!isOrgAdmin && (
          <p style={{ marginTop: "12px", opacity: 0.65, fontSize: "13px" }}>
            Only organization owners can manage billing when self-service
            checkout launches.
          </p>
        )}
      </div>
      </div>
    </CrewPilotModuleShell>
  );
}
